import React from 'react';
import { CubeIcon } from '@heroicons/react/24/outline';

export const moduleConfig = {
  title: 'Module',
  endpoint: 'admin/modules',
  storageKey: 'modules',
  icon: CubeIcon,

  columns: [
    {
      key: 'label',
      label: 'Label',
      render: (item) => <span className="font-medium">{item.label}</span>,
    },
    {
      key: 'slug',
      label: 'Slug',
      render: (item) => <span className="font-mono text-xs text-gray-500">{item.slug}</span>,
    },
    {
      key: 'actions',
      label: 'Actions',
      render: (item) => (
        <div className="flex flex-wrap gap-1">
          {(item.actions || []).map((action) => (
            <span key={action} className="px-2 py-0.5 bg-blue-100 text-blue-700 text-xs rounded-full capitalize">
              {action}
            </span>
          ))}
        </div>
      ),
    },
    {
      key: 'centerScoped',
      label: 'Center Scoped',
      render: (item) =>
        Boolean(item.centerScoped) ? (
          <span className="px-2 py-0.5 bg-amber-100 text-amber-700 text-xs rounded-full">Yes</span>
        ) : (
          <span className="px-2 py-0.5 bg-gray-100 text-gray-500 text-xs rounded-full">No</span>
        ),
    },
    {
      key: 'isActive',
      label: 'Status',
      render: (item) =>
        item.isActive !== false ? (
          <span className="px-2 py-0.5 bg-green-100 text-green-700 text-xs rounded-full">Active</span>
        ) : (
          <span className="px-2 py-0.5 bg-red-100 text-red-600 text-xs rounded-full">Inactive</span>
        ),
    },
  ],

  formFields: [
    {
      name: 'slug',
      label: 'Slug',
      type: 'text',
      required: true,
      placeholder: 'e.g. vaccine-inventory',
      readOnly: (values) => !!values.id,
    },
    {
      name: 'label',
      label: 'Label',
      type: 'text',
      required: true,
      placeholder: 'e.g. Vaccine Inventory',
    },
    {
      name: 'actions',
      label: 'Actions',
      type: 'multi-append',
      required: true,
      tooltip: 'Type an action (e.g. read, create, update, delete) and press Enter',
    },
    {
      name: 'centerScoped',
      label: 'Center Scoped',
      type: 'checkbox',
    },
    {
      name: 'centerField',
      label: 'Center Field',
      type: 'text',
      placeholder: 'e.g. centerId',
    },
  ],

  searchFields: ['label', 'slug'],
};
